import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38000e8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Deine Daten gehören dir. Für einen realistischen Schätzwert benötigen wir Informationen zu deiner Immobilie, z.B. deren Standort und Größe. Der Verwendung dieser Daten kannst du ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("jederzeit widersprechen")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sd_link = _resolveComponent("sd-link")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createBlock(_component_info_box, {
    iconType: "lock",
    title: "Unser Datenversprechen an dich",
    id: "data-protection",
    "is-grey": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _hoisted_1,
        _createVNode(_component_sd_link, {
          inline: "",
          href: "mailto:datenschutz@immowelt.de",
          class: "read-more"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _hoisted_3
      ])
    ]),
    _: 1
  }))
}